import { createFileRoute } from "@tanstack/react-router";
import TransparencyPage from "@project/user/pages/trust/transparency";

export const Route = createFileRoute("/_user/_trust/transparency")({
  head: () => ({
    meta: [
      { title: "Transparency & Impact — Jivandhara" },
      {
        name: "description",
        content:
          "Every rupee tracked, every outcome reported. See where donations go, our annual highlights and the achievements of our trust.",
      },
      { property: "og:title", content: "Transparency & Impact — Jivandhara" },
    ],
  }),
  component: TransparencyPage,
});
